import { Link } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";

const HeroAbout = () => {
  const features = [
    "Residential & Commercial Construction",
    "Property Development Solutions",
    "Property Buying & Selling",
    "Government Liaisoning Services",
  ];

  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">

          {/* Left Image */}

          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src="assets/images/about.png"
              alt="AZ Construction"
              className="rounded-3xl shadow-xl w-full"
            />

            {/* Experience Card */}

            <div className="absolute -bottom-6 -right-2 sm:-bottom-8 sm:-right-6 bg-[#082B57] p-4 sm:p-6 rounded-2xl shadow-xl">
              <h3 className="text-3xl sm:text-4xl font-bold text-[#F59E0B]">
                10+
              </h3>
              <p className="text-white text-sm">
                Years Experience
              </p>
            </div>
          </motion.div>

          {/* Right Content */}

          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="text-[#F59E0B] font-semibold uppercase tracking-wider">
              About AZ Construction
            </span>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4 leading-tight">
              Building Excellence &
              <span className="text-[#F59E0B]">
                {" "}Creating Value
              </span>
            </h2>

            <p className="text-gray-600 mt-6 leading-8">
              AZ Construction is a trusted name in construction,
              property development, property dealing, and liaisoning
              services. We are committed to delivering high-quality
              projects with transparency, professionalism, and
              customer satisfaction.
            </p>

            <p className="text-gray-600 mt-4 leading-8">
              Whether you're planning your dream home, investing in
              property, or seeking professional development services,
              our experienced team ensures every project is completed
              with precision and excellence.
            </p>

            {/* Features */}

            <div className="grid sm:grid-cols-2 gap-4 mt-8">

              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3"
                >
                  <FaCheckCircle className="text-[#F59E0B] mt-1" />

                  <span className="text-gray-700">
                    {item}
                  </span>
                </div>
              ))}

            </div>

            {/* Buttons */}

            <div className="mt-10 flex flex-col sm:flex-row gap-4 max-w-md sm:max-w-none">

              <Link
                to="/about-us"
                className="w-full sm:w-auto bg-[#F59E0B] hover:bg-orange-600 transition px-8 py-4 rounded-xl text-white font-semibold flex items-center justify-center"
              >
                Read More
              </Link>

              <Link
                to="/contact-us"
                className="w-full sm:w-auto border-2 border-[#082B57] text-[#082B57] hover:bg-[#082B57] hover:text-white transition px-8 py-4 rounded-xl font-semibold flex items-center justify-center"
              >
                Contact Us
              </Link>

            </div>

          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HeroAbout;